module.exports = __webpack_public_path__ + "images/category_lp/smartphone/store_images/2_5aa1a6f52fba943db1f28011afaa2440.png";